<template>
  <div class="ma-3 mt-6">
    <v-card
      v-if="
        checkaccessdata.is_viewer == false && checkaccessdata.is_maker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card class="overflow-hidden" v-else>
      <br />
      <v-data-table
        dense
        :headers="headers"
        :items="getRuleslist"
        :search="search"
        :options.sync="pagination"
        :items-per-page="itemsPerPage"
        @update:options="getExpenseCategoryPagination()"
        :no-data-text="Nodata"
      >
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ getRuleslist.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.cat_code`]="{ item }">
          <span class="caption">{{ item.cat_code }}</span>
        </template>
        <template v-slot:[`item.usertype`]="{ item }">
          <span class="caption">{{ item.usertype }}</span>
        </template>
        <template v-slot:[`item.trans_freq`]="{ item }">
          <span class="caption">{{ convertTransectn(item.trans_freq) }}</span>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <span class="caption">MYR {{ item.amount }}</span>
        </template>
        <template v-slot:[`item.created_on`]="{ item }">
          <span class="caption">{{ item.created_on }}</span>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <span class="green--text" v-if="item.status == 1">ACTIVE</span>
          <span class="red--text" v-if="item.status == 0">DELETED</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon @click="showContent(item)" small class="mr-2" color="primary"
            >mdi-eye</v-icon
          >

          <v-icon
            color="red"
            @click="Delete(item)"
            small
            :disabled="item.status == 0"
            >mdi-delete</v-icon
          >
        </template>

        <template v-slot:top>
          <v-layout row wrap>
            <v-row class="mb-3">
              <v-col cols="3">
                <v-card-title class="ml-2 primary--text">
                  <v-btn @click="back" class="ml-n7 primary--text" text>
                    <v-icon>mdi-reply</v-icon></v-btn
                  >
                  Expense Rules
                </v-card-title>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="mt-4 mr-8">
                <v-text-field
                  v-model="search"
                  shaped
                  outlined
                  dense
                  class="mt-n1"
                  color="primary"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="mt-3 mr-8">
                <v-dialog persistent v-model="addCategory" width="550">
                  <v-toolbar dark dense class="header">
                    <v-icon>mdi-plus</v-icon>
                    <span class="ml-3">Add Expense Rules</span>
                    <v-spacer></v-spacer>
                    <v-btn class text dark @click="clearData">
                      <v-icon color="white" small>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <template #activator="{ on: addCategory }">
                    <v-tooltip bottom color="primary">
                      <template #activator="{ on: tooltip }">
                        <v-btn
                          class="ml-n9 mt-1 navbar elevation-0 white--text"
                          rounded
                          v-on="{ ...addCategory, ...tooltip }"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text">Add Expense Rules</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-divider></v-divider>
                    <v-form ref="formExpense">
                      <v-row class="mt-8 mx-7">
                        <v-col cols="12" class="mt-n4">
                          <v-select
                            v-model="categoryName"
                            :rules="nameRules"
                            label="Category Name *"
                            color="primary"
                            :items="itemsCategary"
                            item-text="cat_code"
                            item-value="cat_id"
                            required
                            outlined
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" class="mt-n5">
                          <v-select
                            v-model="userTypeDestn"
                            color="primary"
                            :items="userTypelist"
                            item-text="usetTypeFN"
                            item-value="ut_id"
                            label="User Type"
                            outlined
                            dense
                          ></v-select>
                        </v-col>

                        <v-col cols="6" class="mt-n5">
                          <v-text-field
                            :rules="nameRules"
                            v-model="amountMYR"
                            label="Amount(MYR)"
                            outlined
                            dense
                            required
                            @keypress="isNumber(event)"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="mt-n5">
                          <v-select
                            v-model="trasectnValue"
                            :rules="nameRules"
                            :items="itemsTransection"
                            label="Transaction Frequency"
                            outlined
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" class="mt-n5">
                          <v-text-field
                            v-model="rulesValue"
                            color="primary"
                            :rules="nameRules"
                            @keydown.space="preventLeadingSpace"
                            label="Rule Description"
                            required
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mt-n5">
                          <v-textarea
                            outlined
                            :rules="nameRules"
                            dense
                            label="Rule Summary"
                            rows="2"
                            v-model="commentExpense"
                            @keydown.space="preventLeadingSpace"
                            auto-grow
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        rounded
                        class="primary elevation-6 white--text mt-n4 mr-2 mb-2"
                        :loading="isLoading"
                        medium
                        @click="createCatExpense"
                      >
                        Add
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="showcommStatus" max-width="600" class="overflow-y-auto">
      <v-card>
        <v-toolbar flat color="primary" dense dark>
          <v-toolbar-title>Expense Rules Details</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="showcommStatus = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="4">
              <span class="subtitle-2">
                <b class="primary--text">CATEGORY NAME :</b>
              </span>
            </v-col>
            <v-col cols="6">
              <span> {{ commentsDetails.cat_code }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="subtitle-2 mb-n4">
                <b class="primary--text">USER TYPE :</b>
              </span>
            </v-col>
            <v-col cols="6">
              <span> {{ commentsDetails.usertype }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="subtitle-2 mb-n4">
                <b class="primary--text">AMOUNT :</b>
              </span>
            </v-col>
            <v-col cols="6">
              <span> {{ commentsDetails.amount }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="subtitle-2 mb-n4">
                <b class="primary--text">TXN FREQUENCY :</b>
              </span>
            </v-col>
            <v-col cols="6">
              <span> {{ convertTransectn(commentsDetails.trans_freq) }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="subtitle-2 mb-n4">
                <b class="primary--text">CREATED ON :</b>
              </span>
            </v-col>
            <v-col cols="6">
              <span> {{ commentsDetails.created_on }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="subtitle-2 mb-n4">
                <b class="primary--text">RULE DESCRIPTION :</b>
              </span>
            </v-col>
            <v-col cols="6">
              <span> {{ commentsDetails.rule_desc }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="subtitle-2 mb-n4">
                <b class="primary--text">RULE SUMMARY :</b>
              </span>
            </v-col>
            <v-col cols="6">
              <span> {{ commentsDetails.rule_summary }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteDialog1" width="400" persistent>
      <v-card class="overflow-hidden">
        <v-toolbar class="elevation-0" dense>
          <span> Are you sure you want to submit ? </span>
          <v-spacer></v-spacer>
          <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
        </v-toolbar>
        <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-row class="mt-2" style="margin-left: 200px">
            <v-btn
              text
              width="90px"
              class="mb-4 red--text"
              @click="confirmDeleteDialog1 = false"
              >Back</v-btn
            >
            <v-btn
              text
              width="90px"
              class="mb-4 primary--text"
              @click="deleteItem()"
              >Submit</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OverleyProccessg :overlay="overlay" />
  </div>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
import OverleyProccessg from "@/Views/OverleyProccessg.vue";

export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    confirmDeleteDialog1: false,
    nameRules: [(v) => !!v || "Required"],
    userTypeDestn: "",
    commentExpense: "",

    categoryName: "",
    commentsDetails: {},
    amountMYR: "",
    trasectnValue: "",
    itemsTransection: ["Per Day", "Per Transaction"],
    categoryTablelist: [],

    categoryList: [
      "Hotels/Motels/Inns/Resorts",
      "UNITED AIRLINES",
      "Golf Courses – Public",
      "Amusement Parks, Carnivals, Circuses, Fortune Tellers",
    ],
    rulesValue: "",
    addCategory: false,
    search: "",
    isLoading: false,
    Address: "",
    showcommStatus: false,
    Name: "",
    Description: "",
    markers: [],
    startCategory: {
      lat: 80,
      lng: 90,
    },
    getdepartmentlist: [],
    headers: [
      { text: "SL NO", value: "sl_no", width: "2px", sortable: false },
      {
        text: "CATEGORY NAME",
        value: "cat_code",
        width: "5px",
        sortable: false,
      },
      {
        text: "USER TYPE",
        value: "usertype",
        width: "1px",
        sortable: false,
      },
      {
        text: "AMOUNT(MYR)",
        value: "amount",
        width: "5px",
        sortable: false,
      },

      {
        text: "TRANSACTION FREQUENCY",
        value: "trans_freq",
        width: "5px",
        sortable: false,
      },

      {
        text: "CREATED ON",
        value: "created_on",
        width: "5px",
        sortable: false,
      },
      // {
      //   text: "DETAILS",
      //   value: "details",
      //   width: "5px",
      //   sortable: false,
      // },
      {
        text: "STATUS",
        value: "status",
        width: "5px",
        sortable: false,
      },

      {
        text: "ACTIONS",
        value: "action",
        width: "5px",
        sortable: false,
      },
    ],
    getRuleslist: [],
    Nodata: "",
    itemsPerPage: 25,
    overlay: false,
    itemsCategary: [],
    userTypelist: [],
    IsMapped: 0,
    catId: "",
    status: 0,
    checkaccessdata: {},
  }),
  mounted() {
    this.checkaccess();
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "SETTINGS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getCatDetails();
        //  console.log("marksers", this.markers);
        this.getExpenseCategory();
        this.userTypeList();
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },
    async userTypeList() {
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GCUSRTP",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log(responseData.data.data);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var res = responseData.data.data;
          res.forEach((element) => {
            this.userTypelist.push({
              usetTypeFN:
                element.ut_name +
                "-(" +
                element.role_name +
                "/" +
                element.grade_name +
                "/" +
                element.loc_name +
                ")",
              ut_id: element.ut_id,
            });
          });
        }
      } else {
        this.userTypelist = [];
      }
    },
    async getCatDetails() {
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCAT",
          // search_text: "",
          corp_id: this.$store.getters.get_corpid, // 0
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.itemsCategary = responseData.data.data;
          // console.log("this.itemsCategary", this.itemsCategary);
        }
      } else {
        this.itemsCategary = [];
      }
    },
    convertTransectn(data) {
      return data == "1" ? "Per Day" : "Per Transaction";
    },
    async createCatExpense() {
      //alert(90);
      if (this.$refs.formExpense.validate()) {
        this.isLoading = true;
        var inputData = {
          method_name: "EXPENSE",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "CEXRULE",
            corp_id: this.$store.getters.get_corpid,
            cat_id: this.categoryName,
            ut_id: this.userTypeDestn,
            amount: this.amountMYR,
            trans_freq: this.trasectnValue == "Per Day" ? 1 : 2,
            rule_desc: this.rulesValue,
            rule_summary: this.commentExpense,
          },
        };
        //console.log("inputData", inputData);
        var responseData = await apiCall(inputData);
        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.getExpenseCategory();
          this.clearData();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.clearData();
        }
      }
    },
    preventLeadingSpace(e) {
      // only prevent the keypress if the value is blank
      if (!e.target.value) e.preventDefault();
      // otherwise, if the leading character is a space, remove all leading white-space
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    showContent(data) {
      //   console.log(data);
      this.commentsDetails = data;
      this.showcommStatus = true;
    },
    clearData() {
      this.addCategory = false;
      this.isLoading = false;
      this.$refs.formExpense.reset();
      this.$refs.formExpense.resetValidation();
    },
    async getExpenseCategoryPagination() {
      if (this.getRuleslist.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "EXPENSE",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "GEXRULE",
            // corp_id: "this.$store.getters.get_corpid",
            corp_id: this.$store.getters.get_corpid,
            search_text: "",
          },
        };

        var responseData = await apiCall(inputData);

        this.getRuleslist = this.getRuleslist.concat(responseData.data.data);
      }
    },
    async getExpenseCategory() {
      this.overlay = true;
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 50,
        app_code: "CPORTAL",
        method_param: {
          action: "GEXRULE",
          // corp_id: "this.$store.getters.get_corpid",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.overlay = false;
          this.getRuleslist = responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        }
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.overlay = false;
        this.getRuleslist = [];
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    Delete(item) {
      // console.log("idf", item);
      this.confirmDeleteDialog1 = true;
      // this.Name = item.name;
      // this.EditCat = item.cat_code;
      // this.EditDescr = item.cat_desc;
      this.status = item.status;
      this.IsMapped = item.is_mapped;
      this.catId = item.category_id;
    },
    async deleteItem() {
      var inputData = {
        method_name: "SETTINGS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "DELRULES",

          category_id: this.catId,
          corp_id: this.$store.getters.get_corpid,
        },
      };
      // console.log("cardmaster_id", this.cardmaster_id);
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.confirmDeleteDialog1 = false;
        this.$store.commit("snackbar/showMessage", {
          content: "Deleted successfully",
          color: "green",
        });
        this.getExpenseCategory();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.confirmDeleteDialog1 = false;
      }
    },
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
